export const STARRANK_CONTEXT_MENU = [
  {label: '나중에 보기', type: 'view-later'},
  {label: '공유하기', type: 'share'},
];
